import { createIcon } from './createIcon'

export const MailIcon = createIcon({
  displayName: 'MailIcon',
  viewBox: '0 0 16 12',
  path: [
    <path
      d="M0.00333343 1.88355L7.99995 5.88186L15.9967 1.8835C15.9363 0.833152 15.0655 0 14 0H2C0.934518 0 0.0636347 0.833179 0.00333343 1.88355Z"
      fill="currentColor"
    ></path>,
    <path
      d="M16 4.1179L7.99995 8.11793L0 4.11796V10C0 11.1046 0.895431 12 2 12H14C15.1046 12 16 11.1046 16 10V4.1179Z"
      fill="currentColor"
    ></path>,
  ],
})
